import styled from 'styled-components'

const Wrapper = styled.div`
  /* pointer-events: none; */
  /* z-index: -1;
  position: relative; */
`

export { Wrapper }
